var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.data, function (category, index) {
      return _c("BaseBadge", {
        key: index,
        attrs: {
          cyPrefix: `${_vm.cyPrefix}-badge-category-${index}`,
          data: category,
          variant: "info",
        },
        on: {
          onDelete: function ($event) {
            return _vm.onDelete(index)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }